const AdminView = () => import('@/views/Admin/AdminView')
const Aso = () => import('@/views/Admin/Aso')
const Clinica = () => import('@/views/Admin/Clinica')
const Usuarios = () => import('@/views/Admin/Usuarios')
const MedicoAdmin = () => import('@/views/Admin/MedicoAdmin')
const Faturamento = () => import('@/views/Admin/Faturamento')
const CadastroRapido = () => import('@/views/Admin/CadastroRapido')
const AgendaMedica = () => import('@/views/Admin/AgendaMedica')
const NovosNegocios = () => import('@/views/Home/NovosNegocios')
const Exames = () => import('@/views/Admin/Exames')
const Riscos = () => import('@/views/Admin/Riscos')
const DocumentoSSO = () => import('@/views/Admin/DocumentoSSO')
const Avisos = () => import('@/views/Admin/Avisos')
const DetalhesFatura = () => import('@/views/Home/DetalhesFatura')
const GerenciarAtendimentos = () => import('@/views/Admin/GerenciarAtendimentos')
const FinanceiroClinica = () => import('@/views/Admin/FinanceiroClinica')
const Chamados = () => import('@/views/Admin/Chamados')
const KpiChamados = () => import('@/views/Admin/KpiChamados')
const Art = () => import('@/views/Home/Art')
export default {
  path: 'admin/',
  name: 'admin',
  component: AdminView,
  children: [
    { path: 'asos', name: 'admin-asos', component: Aso },
    { path: 'clinicas', name: 'admin-clinicas', component: Clinica },
    { path: 'usuarios', name: 'admin-usuarios', component: Usuarios },
    { path: 'medicos', name: 'admin-medicos', component: MedicoAdmin },
    { path: 'faturamento', name: 'admin-faturamento', component: Faturamento },
    { path: 'cadastro-rapido', name: 'cadastro-rapido', component: CadastroRapido },
    { path: 'agenda-medica', name: 'admin-agenda-medica', component: AgendaMedica },
    { path: 'chamados', name: 'chamados', component: Chamados },
    { path: 'kpi-chamados', name: 'kpi-chamados', component: KpiChamados },
    { path: 'novos-negocios', name: 'admin-novos-negocios', component: NovosNegocios },
    { path: 'exames', name: 'admin-exames', component: Exames },
    { path: 'riscos', name: 'admin-riscos', component: Riscos },
    { path: 'documento-sso', name: 'admin-documento-sso', component: DocumentoSSO },
    { path: 'avisos', name: 'admin-avisos', component: Avisos },
    { path: 'informacoes-fatura/:id', name: 'informacoes-fatura', component: DetalhesFatura, props: true },
    // { path: 'faturamento/:empresa', name: 'faturamento', component: Faturamento, props: true },
    { path: 'gerenciar-atendimentos', name: 'gerenciar-atendimentos', component: GerenciarAtendimentos },
    { path: 'financeiro-clinica', name: 'financeiro-clinica', component: FinanceiroClinica },
    { path: 'art', name: 'admin-art', component: Art, props: { admin: true } },
  ],
}
